import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  DownloadCarteira,
  FileGenerationFilter,
  ReportDraweeRegister,
  ReportFilterDialog,
  ReportRegister,
} from '../../models';
import { ReportBatch } from '../../models/report-batch.model';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private readonly API = `${environment.api_url}/Relatorios`;

  constructor(private http: HttpClient) {}

  getReceivablesHistory(receivableId: number): Observable<any> {
    return this.http.get<any>(
      `${this.API}/historicoRecebivel/${receivableId}`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          responseType: 'blob',
        }),
        responseType: 'blob' as 'json',
      }
    );
  }

  generateRelatorio(body): Observable<unknown> {
    return this.http.post(`${this.API}/GenerateRelatorioEspecifico`, body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'blob',
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  getRelatorios(
    nameFund: string | null,
    date: string,
    emailUsuario: string
  ): Observable<ReportBatch[]> {
    return this.http.post<ReportBatch[]>(`${this.API}/GetRelatoriosGeral`, {
      nomeFundo: nameFund,
      usuarioEmail: emailUsuario,
      dataSolicitacao: date,
    });
  }

  downloadRelatorio(id: number, emailUsuario: string): Observable<unknown> {
    return this.http.post(
      `${this.API}/DownloadRelatorioGeral`,
      {
        idRelatorioGeral: id,
        emailUsuario: emailUsuario,
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          responseType: 'blob',
        }),
        observe: 'response',
        responseType: 'blob' as 'json',
      }
    );
  }

  getFiltrosRelatorio(id: number): Observable<ReportFilterDialog> {
    return this.http.get<ReportFilterDialog>(`${this.API}/filtros/${id}`);
  }

  historyEvolution(body): Observable<unknown> {
    return this.http.post(`${this.API}/EvolucaoHistorica`, body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'blob',
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  downloadDraweeReport(body: ReportDraweeRegister): Observable<unknown> {
    return this.http.get(`${this.API}/cadastros/sacado`, {
      params: {
        idFundo: body.idFundo,
        comRepresentante: body.comRepresentante,
      },
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'blob',
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  dowmloadAssignorReport(body): Observable<unknown> {
    return this.http.get(`${this.API}/cadastros/cedente`, {
      params: {
        idFundo: body.idFundo,
      },
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'blob',
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  downloadWallet(body): Observable<unknown> {
    return this.http.get(`${this.API}/DownloadCarteira`, {
      params: body,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'blob',
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
